/**
 * Format a date value as dd.mm.yyyy (Icelandic standard with leading zeros).
 * Accepts Date objects, ISO strings, or any value parseable by new Date().
 */
export const fmtDateIS = (value) => {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return String(value);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};
